import { SIGNUP_CONTRACT_APPROVALS_KEY } from "constants/moduleConstants/contract.constant";
import { getItem, setItem, removeItem } from "utils/safeStorage";

export const saveSignupContractApprovals = (contractVersionIds = []) => {
  const ids = [...new Set(contractVersionIds.filter(Boolean))];
  if (!ids.length) {
    removeItem(SIGNUP_CONTRACT_APPROVALS_KEY);
    return;
  }
  setItem(SIGNUP_CONTRACT_APPROVALS_KEY, JSON.stringify(ids));
};

export const readSignupContractApprovals = () => {
  try {
    const raw = getItem(SIGNUP_CONTRACT_APPROVALS_KEY);
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch {
    return [];
  }
};

export const clearSignupContractApprovals = () => {
  removeItem(SIGNUP_CONTRACT_APPROVALS_KEY);
};
